import React from 'react';

const NotAvailableValue = ({ text = 'Chưa cập nhật' }) => <span className="text-muted">{text}</span>;
export default NotAvailableValue;
